import React, { useState, useEffect, useRef, useCallback } from 'react'

// Deps
import { connect } from 'react-redux'

// Functions
import formatDate from 'functions/format-date'
import padStart from 'lodash/padStart'

// Utils
// import { openModal } from 'utils/modals';

// Partials
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Collapser from 'views/shared/partials/collapser'
import Pricebox from 'views/shared/partials/pricebox'

// Services
import reportServices from 'services/report'

// Hooks
import useGroups from 'hooks/groups'
import useSelectQuery from 'hooks/select-query'

// Data
import rawCurrencyTypes from 'data/currency-types'

const defaultCurrencyType = { value: '0', label: 'Tümü' }
const currencyTypes = [defaultCurrencyType, ...rawCurrencyTypes]

const getDefaultSelectQuery = () => {
	return {
		'store_code': { value: '', label: 'Tüm Gruplar' },
	}
}

const calculateSelectValue = (value, key, groups) => {
	return new Promise((resolve) => {
		if (key === 'price_type_id') {
			resolve({
				key: key, value: [defaultCurrencyType, ...currencyTypes].find((opt) => {
					return opt.value.toString() === value.toString()
				})
			});
		}
		else if (key === 'store_code') {
			resolve({
				key: key, value: groups.find((opt) => {
					return opt.value.toString() === value.toString()
				})
			});
		}
		else {
			resolve(false);
		}
	});
}

const mapStateToProps = (state, ownProps) => {
	return {
		userGroups: state.user.groups,
	};
};

const CostReportList = (props) => {
	const query = props.query;
	const plain = props.plain;

	const searchForm = useRef();

	const [data, setData] = useState(false);
	
	const groups = useGroups(props.userGroups);
	const selectQuery = useSelectQuery(query, groups, calculateSelectValue, getDefaultSelectQuery);

	const getData = useCallback(() => {
		setData(false);

		reportServices.getCostReports(query).then((payload) => {
			let reportGroups = [];

			for(let report of payload) {
				let groupNth = false;

				for(let p = 0; p < reportGroups.length; p++){
					if(reportGroups[p].year === report.year && reportGroups[p].month === report.month){
						groupNth = p;
					}
				}

				if(groupNth !== false) {
					reportGroups[groupNth].reports.push(report);
				}
				else {
					reportGroups.push({
						year: report.year,
						month: report.month,
						reports: [report],
					});
				}
			}

			setData(reportGroups);
		}).catch((error) => {
		});
	}, [query]);

	useEffect(() => {
		getData();	
	}, [query, getData])

	return (
		<section className={'portlet section cost-report-list ' + (props.className ? props.className : '')}>
			<div className="portlet-header">
				<strong className="portlet-title">Kullanım Raporları</strong>
			</div>

			{!plain &&
				<InputForm
					ignoreEmpty
					className="portlet-filters"
					ref={searchForm}
					onSubmit={props.onSearch}>
					<div className="filters-more grid-container show">
						<div className="row">
							<div className="col x6">
								<FormInput
									type="select"
									isSearchable
									z="5"
									defaultValue={selectQuery['store_code'] ? selectQuery['store_code'] : groups[0]}
									label="Grup"
									options={groups}
									name="store_code" />
							</div>
							<div className="col x6">
								<FormInput
									z="2"
									type="select"
									label="Para Birimi"
									options={currencyTypes}
									defaultValue={selectQuery['price_type_id'] ? selectQuery['price_type_id'] : defaultCurrencyType}
									name="price_type_id" />
							</div>
						</div>
						<div className="row">
							<div className="col more-controls">
								<Btn
									small wide white
									type="submit"
									icon="search">
									Sonuçları Getir
									</Btn>
							</div>
						</div>
					</div>
				</InputForm>
			}
			<div className="portlet-section bottom loader-container">
				<Loader loading={!data} />

				{data &&
					<React.Fragment>
						{data.map((group, nth) => (
							<Collapser
								key={nth}
								className="portlet-section border-top"
								title={<React.Fragment>
									<span>{formatDate(group.year + '-' + padStart(group.month, 2, '0') + '-01', 'MMMM yyyy')}</span> <span className="label">{group.reports.length} Rapor</span>
								</React.Fragment>}>
								
								<Table
									className="list-table"
									heading={
										<React.Fragment>
											<th>Grup</th>
											<th>Para Birimi</th>
											<th>İşlem Adedi</th>
											<th>İşlem Hacmi</th>
											<th>Maliyet</th>
										</React.Fragment>
									}>
									{group.reports.map((report, rnth) => (
										<TR key={rnth} mobileTitle={report.group + ' (' + report.currency_code + ')'}>
											<TD hideMobile>
												{report.group}
											</TD>
											<TD hideMobile>
												{report.currency_code}
											</TD>
											<TD mobileTitle="İşlem Adedi" className="mobile-full">
												{report.count}
											</TD>
											<TD mobileTitle="İşlem Hacmi">
												<Pricebox
													price={report.price}
													currency={report.currency_symbol} />
											</TD>
											<TD mobileTitle="Maliyet">
												<Pricebox
													warning
													price={report.maliyet}
													currency={report.currency_symbol} />
											</TD>
										</TR>
									))}
								</Table>
							</Collapser>
						))}
					</React.Fragment>
				}
			</div>
		</section>
	)
}

CostReportList.defaultProps = {
	query: {},
	groupID: false,
	onPaginate: () => {},
	onSearch: () => {},
}

export default connect(mapStateToProps)(CostReportList);